export function getProductCardSizeV2 (clientWidth: number): 'desktop' | 'tablet' | 'mobile' | undefined {
  if (typeof clientWidth === 'number') {
    return (clientWidth >= 320
      ? 'desktop'
      : (clientWidth >= 224
        ? 'tablet'
        : 'mobile'
      )
    );
  }
}
